import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var LocationNavigation = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LocationNavigation_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.634 5.908c-.989.414-.769 1.864.298 1.97l6.506.646 1.34 6.65c.204 1.017 1.624 1.126 1.985.153l.67-1.808.853-2.328 1.999-5.36 1.649-4.445c.313-.844-.539-1.652-1.373-1.303L.634 5.908Zm9.124 9.068L8.273 7.602l-7.242-.72a.138.138 0 0 1-.023-.003h-.001A.065.065 0 0 1 1 6.859a.067.067 0 0 1 0-.019.141.141 0 0 1 .019-.01l13.927-5.824c.012-.005.02-.006.02-.006h.002c.002 0 .01.003.02.013.006.006.01.01.01.013a.08.08 0 0 1-.003.012l-1.649 4.446-1.998 5.357-.853 2.33-.002.004-.669 1.805a.112.112 0 0 1-.008.017.074.074 0 0 1-.028.003.076.076 0 0 1-.027-.007.118.118 0 0 1-.004-.017Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LocationNavigation_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default LocationNavigation;